import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/auth/refresh")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          const { refreshDashboardSessionResponse } = await import("@api/auth/dashboardAuthApi")
          return refreshDashboardSessionResponse(request)
        },
      },
    },
  })
)
